import { useQueryClient } from "react-query";
import { QUERY_KEY } from "@circle-react/hooks/usePaywallsInfiniteQuery";

export const useInvalidatePaywallQueries = () => {
  const queryClient = useQueryClient();

  const invalidatePaywallQueries = () => {
    // Invalidate all paywall queries - this will refresh both the tab queries and count queries
    void queryClient.invalidateQueries(QUERY_KEY);
  };

  return { invalidatePaywallQueries };
};
